"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uniqid = _interopRequireDefault(require("uniqid"));

var _DatePickerStyled = require("./DatePicker-styled");

var _reactDates = require("react-dates");

var _reactMomentProptypes = _interopRequireDefault(require("react-moment-proptypes"));

var _ThemedStyleSheet = _interopRequireDefault(require("react-with-styles/lib/ThemedStyleSheet"));

var _reactWithStylesInterfaceAphrodite = _interopRequireDefault(require("react-with-styles-interface-aphrodite"));

var _CalciteThemeProvider = require("../CalciteThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

_ThemedStyleSheet.default.registerInterface(_reactWithStylesInterfaceAphrodite.default);

_ThemedStyleSheet.default.registerTheme(_CalciteThemeProvider.DatePickerTheme);

var DatePicker = function DatePicker(_ref) {
  var field = _ref.field,
      form = _ref.form,
      onFocusChange = _ref.onFocusChange,
      onDateChange = _ref.onDateChange,
      disabled = _ref.disabled,
      name = _ref.name,
      value = _ref.value,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["field", "form", "onFocusChange", "onDateChange", "disabled", "name", "value", "children"]);

  var touched, isSubmitting, setFieldValue, setTouched;

  if (field) {
    value = field.value;
    name = field.name;
    touched = form.touched;
    isSubmitting = form.isSubmitting;
    setFieldValue = form.setFieldValue;
    setTouched = form.setTouched;
  }

  var _onDateChange = function _onDateChange(date) {
    if (setFieldValue) {
      setFieldValue(name, date);
    }

    if (onDateChange) {
      onDateChange(date);
    }
  };

  var _onFocusChange = function _onFocusChange(options) {
    if (setTouched && !options.focused) {
      setTouched(_objectSpread({}, touched, _defineProperty({}, name, true)));
    }

    if (onFocusChange) {
      onFocusChange(options);
    }
  };

  return _react.default.createElement(_DatePickerStyled.StyledDatePickerContainer, null, _react.default.createElement(_reactDates.SingleDatePicker, _extends({
    date: value,
    onDateChange: _onDateChange,
    onFocusChange: _onFocusChange,
    disabled: isSubmitting || disabled
  }, other)));
};

DatePicker.propTypes = {
  /** The currently selected moment date object for the component */
  date: _reactMomentProptypes.default.momentObj,

  /** Callback function when the selected date is changed */
  onDateChange: _propTypes.default.func.isRequired,

  /** Describe whether the DatePicker is currently focused, displays the calendar dropdown */
  focused: _propTypes.default.bool,

  /** Callback function when the focus state of the DatePicker is changed */
  onFocusChange: _propTypes.default.func.isRequired,

  /** Placeholder text for the Datepicker textfield */
  placeholder: _propTypes.default.string,

  /** An id supplied to the DatePicker */
  id: _propTypes.default.string.isRequired
};
DatePicker.defaultProps = {
  placeholder: 'Date',
  id: (0, _uniqid.default)()
};
DatePicker.displayName = 'DatePicker';
var _default = DatePicker;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/DatePicker/DatePicker.js
// module id = 1581
// module chunks = 0